export const DEFAULT_PROJECT = {
  title: "Etkileşimli Videom",
  videoUrl: "",
  interactions: []
};

export function getDefaultDraft(type) {
  if (!type) {
    type = "multiple_choice";
  }

  return {
    type: type,
    timeSec: 10,
    hintDurationSec: 10,
    prompt: "",
    revealText: "",
    backgroundImageUrl: "",
    exampleImageUrl: "",
    wordBankSentenceText:
      "*Oslo* Norveç'in başkentidir ve *Ankara* Türkiye'nin başkentidir.",
    wordBankDistractorsText: "Stockholm\nBerlin",
    // Group number per blank (0 = fixed/position-locked; same number = the
    // blanks are interchangeable). Kept in sync with the sentence's blanks.
    wordBankGroupNumbers: [],
    mcSelectionMode: "single",
    mcOptions: [
      {
        text: "Seçenek A",
        isCorrect: true,
        tipText: "",
        selectedFeedback: "",
        unselectedFeedback: ""
      },
      {
        text: "Seçenek B",
        isCorrect: false,
        tipText: "",
        selectedFeedback: "",
        unselectedFeedback: ""
      }
    ],
    trueFalseCorrect: true,
    dragDropSlotsText:
      "CEREMONIES\nPOETRY AND LANGUAGE FEATURES\nCULTURAL TRANSMISSION",
    dragDropItemsText:
      "Hecce olcusu\nKopuz esliginde\nyug\ndortluk\nsolen\nsigir",
    dragDropCorrectMap: [[4, 5], [0, 3], [2, 1]],
    dragDropAllowReuse: false,
    enableRetry: true,
    showSolution: true
  };
}

export function makeId() {
  return "q_" + Math.random().toString(36).slice(2, 10);
}

export function toSecondsLabel(value) {
  const minutes = Math.floor(value / 60);
  const seconds = Math.floor(value % 60);
  return minutes + ":" + seconds.toString().padStart(2, "0");
}

export function toSecondsMsLabel(value) {
  const safeMs = Math.max(0, Math.round((value || 0) * 1000));
  const minutes = Math.floor(safeMs / 60000);
  const seconds = Math.floor((safeMs % 60000) / 1000);
  const milliseconds = safeMs % 1000;
  return `${minutes}:${seconds.toString().padStart(2, "0")}.${milliseconds
    .toString()
    .padStart(3, "0")}`;
}

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function safeTrim(value) {
  return (value || "").trim();
}

export function readFileAsDataUrl(file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader();

    reader.onload = function () {
      resolve(String(reader.result || ""));
    };

    reader.onerror = function () {
      reject(new Error("Dosya okunamadı"));
    };

    reader.readAsDataURL(file);
  });
}

export const MAX_IMAGE_SIZE_BYTES = 20 * 1024 * 1024;

export function interactionLabel(type) {
  if (type === "multiple_choice") {
    return "Çoktan Seçmeli";
  }

  if (type === "true_false") {
    return "Doğru / Yanlış";
  }

  if (type === "fill_blank") {
    return "Boşluk Doldurma";
  }

  if (type === "info_hint") {
    return "Bilgi / İpucu";
  }

  if (type === "word_bank_fill") {
    return "Cümle Kelime Yerleştirme";
  }

  return "Sürükle Bırak";
}
